
import Table from "react-bootstrap/Table"
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';

import EditRow from "./EditRow"


const GOIBonds = ({ bondType }) => {
  const [tableData, setTableData]=useState([])

  

  const [editField, setEditField] = useState({
    coupon: 0.00,
    maturity: "",
    interestPayout: "",
    rating: "",
    quantum: "",
    bondType:""
  })
  const [showEditRow, setshowEditRow] = useState(false)

  const [addNewRow, setAddNewRow] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`${process.env.REACT_APP_APIURL}/bond/${bondType}`)
      if (response.ok) {
        const data = await response.json()
        setTableData(data)
      }

    }
    fetchData()
  }, [showEditRow])
 
  return (
    <>
    

      <div className="mt-5 p-3 pt-5" >
        <h1 className="text-center " >GOI Bonds </h1>
        
            <>
                <div className='d-flex mb-2 justify-content-between align-items-center'>
                  <Button className=' ' variant="primary" onClick={async () => {
                    await setEditField({
                      "coupon": 0.00, "maturity": "", "interestPayout": "", "rating": "", "quantum": "", "bondtype":""
                    });
                    await setAddNewRow(true);
                    setshowEditRow(true);
                  }}>
                    Add new
                  </Button>
                </div>
              <Table striped bordered hover>

                <thead>
                  <tr>
                    <td>
                      Coupon
                    </td>

                    <td>
                      Maturity
                    </td>
                    <td>
                      Interest Payout Dates
                    </td>
                    <td>
                      Rating
                    </td>
                    <td>Quantum</td>

                  </tr>
                </thead>
                <tbody>
                  {tableData.map((each, index) => (
                    <tr key={each.id} onClick={async (e) => {
                      await setEditField(tableData[index]);
                      setAddNewRow(false);
                      setshowEditRow(true);
                    }}>
                      <td>{each.coupon}</td>
                      <td>{each.maturity}</td>
                      <td>{each.interestPayout}</td>
                      <td>{each.rating}</td>
                      <td>{each.quantum}</td>
                     
                    </tr>
                  ))}

                </tbody>
              </Table></>
          
       
        {showEditRow && <EditRow addNewRow={addNewRow} data={editField} showModal={showEditRow} bondType={bondType} tableName={editField.table_type} closeModal={setshowEditRow} />}
      </div>
    </>

  )
}

export default GOIBonds;  



